import React, { isValidElement } from 'react';
import classNames from 'classnames';
/**
 * The DescriptionList component is our implementation of the
 * [HTML Description List element `<dl>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dl)
 * and is offered in different responsive layout variants.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-description-list.html
 * @constructor
 */
export function DescriptionList({ children, className, grid, horizontal, shortTerms, split, table, testId, ...otherProps }) {
    const classNameList = classNames('c-description-list', {
        // Convenience props from Bronson variants.
        'c-description-list--grid': grid,
        'c-description-list--horizontal': horizontal,
        'c-description-list--terms-short': shortTerms,
        'c-description-list--split': split,
        'c-description-list--table': table,
    }, className).trim();
    return (React.createElement("dl", { className: classNameList, "data-testid": testId, ...otherProps }, children));
}
DescriptionList.displayName = 'DescriptionList';
/**
 * DescriptionListGroup container.
 */
export function DescriptionListGroup({ children, className, id, termClassName, termText, testId, ...otherProps }) {
    const classNameList = classNames('c-description-list__group', className).trim();
    const dtClassNameList = classNames('c-description-list__term', termClassName).trim();
    return (React.createElement("div", { className: classNameList, "data-testid": testId, ...otherProps },
        React.createElement("dt", { className: dtClassNameList, id: id }, termText),
        children));
}
DescriptionListGroup.displayName = 'DescriptionList.Group';
DescriptionList.Group = DescriptionListGroup;
/**
 * DescriptionListDetail container.
 */
export function DescriptionListDetail({ action, children, className, small }) {
    const ddClassNameList = classNames('c-description-list__detail', className).trim();
    return (React.createElement("dd", { className: ddClassNameList },
        children && (React.createElement("span", { className: "c-description-list__text" }, small ? (React.createElement("span", { className: "c-description-list__small-print" }, children)) : (React.Children.map(children, (child) => {
            /**
             * Add CSS class `.c-description-list__small-print` conditionally,
             * only if the child is of type HTMLTimeElement.
             */
            if (isValidElement(child)) {
                if (child?.type === 'time') {
                    const timeProps = child?.props;
                    return React.cloneElement(React.createElement("time", { className: "c-description-list__small-print", dateTime: timeProps?.dateTime }, timeProps?.children));
                }
                else {
                    return child;
                }
            }
            else {
                return child;
            }
        })))),
        action && React.createElement("div", { className: "c-description-list__action" }, action)));
}
DescriptionListDetail.displayName = 'DescriptionList.Detail';
DescriptionList.Detail = DescriptionListDetail;
